<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Payment Summary</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="payrollPeriod"
            v-validate="'required'"
            label="Payroll Period"
            item-text="payroll_date"
            item-value="id"
            :items="payrollPeriods"
            clearable
            hide-selected
            :error-messages="errors.collect('payrollPeriod')"
            data-vv-name="payrollPeriod"  
            data-vv-as="payroll period"
            return-object
          />
        </v-col>

        <v-col />
        <v-col />

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="progressing" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                :loading="progressing"
                color="primary"
                @click="generate"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row> 
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriods: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        progressbar: 0,
        payrollPeriod: null,
      }
    },
    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().paymentSummary(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            }).then(res => {
              let blob = new Blob([res.data], { type: res.data.type })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', 'Payroll Summary ' + this.payrollPeriod.payroll_date + '.xlsx')
              link.click()

              this.progressing = false
              this.progressbar = 0

              this.$snack({ message: 'Report downloaded successfully' })
            }).catch(() => {
              this.progressing = false

              this.$snack({ color: 'error', message: 'Error! Please contact support' })
            })
          })
      },

      prepareFormData () {
        return {
          payroll_period_id: this.payrollPeriod.id,
        }
      },
    },
  }
</script>
